import { render, staticRenderFns } from "./create-org-admin.vue?vue&type=template&id=edcdeb30&scoped=true"
import script from "./create-org-admin.vue?vue&type=script&lang=js"
export * from "./create-org-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcdeb30",
  null
  
)

export default component.exports